import { FC } from 'react'

import { Skeleton, Spacer, ViewportSizes, useIsViewport } from '@syconium/little-miss-figgy'

import {
  HighlightsSkeletonWrapper,
  InfoSkeletonWrapper,
  OptionsSkeletonWrapper,
  ThumbnailSkeleton,
} from './skeletonStyles'

export interface KitProductListItemSkeletonProps {
  hasLengthBlock?: boolean
}

const KitProductListItemSkeleton: FC<KitProductListItemSkeletonProps> = ({
  hasLengthBlock = false,
}) => {
  const isMediumOrLargeViewport = useIsViewport([ViewportSizes.medium, ViewportSizes.large])

  return (
    <div>
      <HighlightsSkeletonWrapper>
        <ThumbnailSkeleton animated />
        <InfoSkeletonWrapper>
          <Skeleton height='14px' />
          <Spacer height={isMediumOrLargeViewport ? 10 : 8} />
          <Skeleton height='14px' />

          <Spacer height={15} />
          <Skeleton height='14px' />
        </InfoSkeletonWrapper>
      </HighlightsSkeletonWrapper>

      <Spacer height={isMediumOrLargeViewport ? 15 : 18} />

      <OptionsSkeletonWrapper>
        <Skeleton height='14px' width='130px' />

        <Spacer height={14} />
        <Skeleton height='22px' />
        <Spacer height={24} />
        <Skeleton height='14px' />
        <Spacer height={14} />
        <Skeleton height='33px' />
        <Spacer height={8} />
        <Skeleton height='33px' />

        {hasLengthBlock ? (
          <>
            <Spacer height={31} />
            <Skeleton height='14px' width='130px' />
            <Spacer height={13} />
            <Skeleton height='28px' />
          </>
        ) : (
          <>
            <Spacer height={17} />
            <Skeleton height='28px' />
          </>
        )}
      </OptionsSkeletonWrapper>
    </div>
  )
}

export default KitProductListItemSkeleton
